import { useCallback } from 'react';

// Disabled sound effects system - maintaining interface for compatibility
export const useSoundEffects = () => {
  // All sound functions are now no-ops
  const playMagicSparkle = useCallback(() => {}, []);
  const playWhoosh = useCallback(() => {}, []);
  const playHappyChime = useCallback(() => {}, []);
  const playBoing = useCallback(() => {}, []);
  const playSleepyTwinkle = useCallback(() => {}, []);
  const cleanup = useCallback(() => {}, []);

  return {
    playMagicSparkle,
    playWhoosh,
    playHappyChime,
    playBoing,
    playSleepyTwinkle,
    cleanup
  };
};